import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "eGeeTouch® Smart Luggage Lock tracks and prevent missing luggage (an optional feature) utilizing GSM, NFC and Bluetooth technologies.",
    reply2:
      "In fact, most of current commercial GPS technologies are unable to reliably detect an object/item when it is located inside a building or stored in a metal shielded container/truck/aeroplane. For example, satellite signal of automotive GPS navigation system usually fails to indicate direction whenever the car is inside a tunnel. However, since mobile phone's GSM's 4G signal has wide coverage and extend inside most buildings and underground transports, eGeeTouch smartlock utilises GSM and/or WIFI via smatphones to precisely track luggage locations with greater convenience.",
    back: "Back",
  },
  ja: {
    reply1:
      "eGeeTouch® スマート ラゲッジ ロックは、GSM、NFC、および Bluetooth テクノロジーを利用して荷物を追跡し、紛失を防止します (オプション機能)。",
    reply2:
      "実際、現在の商用 GPS テクノロジーのほとんどは、物体やアイテムが建物内にある場合、または金属で遮蔽されたコンテナ/トラック/飛行機内に保管されている場合、その物体/アイテムを確実に検出することができません。たとえば、自動車の GPS ナビゲーション システムの衛星信号は、通常、自動車がトンネル内にあるときは常に方向を示すことができません。ただし、携帯電話の GSM の 4G 信号はカバー範囲が広く、ほとんどの建物や地下交通機関内にまで到達するため、eGeeTouch スマートロックはスマートフォン経由で GSM および/または WIFI を利用して、荷物の位置を正確に追跡し、利便性が高まります。",
    back: "戻る",
  },
  es: {
    reply1:
      "El candado inteligente para equipaje eGeeTouch® rastrea y evita la pérdida de equipaje (una característica opcional) utilizando tecnologías GSM, NFC y Bluetooth.",
    reply2:
      "De hecho, la mayoría de las tecnologías GPS comerciales actuales no pueden detectar de manera confiable un objeto/artículo cuando está ubicado dentro de un edificio o almacenado en un contenedor/camión/avión blindado de metal. Por ejemplo, la señal satelital del sistema de navegación GPS para automóviles generalmente no indica la dirección cuando el automóvil está dentro de un túnel. Sin embargo, dado que la señal GSM 4G de los teléfonos móviles tiene una amplia cobertura y se extiende dentro de la mayoría de los edificios y transportes subterráneos, la candado inteligente eGeeTouch utiliza GSM y/o WIFI a través de teléfonos inteligentes para rastrear con precisión la ubicación del equipaje con mayor comodidad.",
    back: "Atrás",
  },
});

class Q4_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <br />
        <br />
        {localizationStrings.reply2}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q4_component;
